import {FlatListDto, FlatListOrder, GraphTimeSpan, LogOverviewDto} from '../../swagger';
import {logOverviewLink} from '../../routing/AppRoutes';
import {FlatListState} from '../../components/flats/FlatListState';
import {DashboardState} from './DashboardState';
import {makeObservable, override} from 'mobx';
import {redirectTo} from '../../routing/browserHistory';

export class DashboardListState extends FlatListState {
    private dashboardState: DashboardState;


    constructor(l: LogOverviewDto, dashboardState: DashboardState) {
        super(true, false);
        makeObservable(this);
        this.showSearch = false;
        this.log = l;
        this.dashboardState = dashboardState;
        this.listParams.graphTimeSpan = dashboardState.graphTimeSpan;
        this.orderBy = dashboardState.orderBy;
    }

    @override
    setGraphTimeSpan(v: GraphTimeSpan) {
        this.dashboardState.setGraphTimeSpan(v);
        this.listParams.graphTimeSpan = v;
    }

    @override
    setOrderBy(v: FlatListOrder) {
        this.dashboardState.setOrderBy(v);
        this.orderBy = v;
    }

    delete(): void {
    }

    flatClickHandler(v: FlatListDto): void {
        redirectTo(logOverviewLink(v.logId!, v.flatId!));
    }

    loadList(loadLast?: boolean): Promise<any> {
        return Promise.resolve(undefined);
    }

    search(): void {
    }
}
